import { useMemo } from 'react';
import type { CSSProperties } from 'react';

import { Box } from '@mui/material';

import { parseMarkdown } from '@modules/_shared/utils/parseMarkdown';

type MarkdownProps = {
  children: string;
  style?: CSSProperties;
};

export const Markdown = ({ children, style }: MarkdownProps) => {
  const html = useMemo(
    () => parseMarkdown(children, { breaks: true, openLinksInNewTab: true }),
    [children],
  );

  return (
    <Box
      sx={{
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        '& > *:first-of-type': {
          marginTop: 0,
        },
        '& *:last-child': {
          marginBottom: 0,
        },
        '& a': {
          color: 'primary.main',
          textDecoration: 'none',
        },
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
